export const fetchDataFromCookies = () => {
  let id: string | null = null;
  let sessionId: string | null = null;
  let token: string | null = null;

  if (typeof window !== "undefined") {
    const getCookie = (name: string) => {
      const match = document.cookie.match(
        new RegExp("(^| )" + name + "=([^;]+)"),
      );
      return match ? match[2] : null;
    };

    const sanitizeCookieValue = (val: string | null) => {
      if (!val || val === "null") return null;

      try {
        return decodeURIComponent(val).replace(/"/g, "");
      } catch {
        return val.replace(/"/g, "");
      }
    };

    let rawId = getCookie("ajs_user_id");
    const rawSessionId = getCookie("sid");
    const rawToken = getCookie("access_token");

    console.log("rawSessionId", rawSessionId);

    if (!rawId || rawId === "null") {
      rawId = getCookie("ajs_anonymous_id");
    }

    id = sanitizeCookieValue(rawId);
    sessionId = sanitizeCookieValue(rawSessionId);
    token = sanitizeCookieValue(rawToken);
  }

  return {
    id,
    sessionId,
    token,
  };
};
